import { testimonials } from "../../../mocks/testimonials";

const AVATAR_COLORS = [
  "bg-[#F2E8DF]",
  "bg-[#E8F0F2]",
  "bg-[#F0EDF8]",
  "bg-[#F2EBE8]",
  "bg-[#EDF2E8]",
  "bg-[#F8F0E8]",
];

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="mb-14">
          <div className="inline-flex items-center gap-2 border border-[#C9A86A] px-4 py-1.5 rounded-full mb-5">
            <span className="w-1 h-1 rounded-full bg-[#C9A86A]" />
            <span className="text-[#C9A86A] text-xs tracking-[0.2em]" style={{ fontFamily: "'Noto Serif JP', serif" }}>お客様の声</span>
          </div>
          <h4 id="reviews" className="text-3xl lg:text-4xl text-[#3D2E2A] leading-snug" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
            <a href="#reviews">BE:NAILをご利用いただいた<br />お客様からの声</a>
          </h4>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className="bg-[#FAF8F6] rounded-xl p-6 border border-[#EDE7DF] hover:-translate-y-0.5 transition-transform duration-200"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A86A] text-xs" />
                  </span>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-[#5A4540] text-sm leading-[1.9] mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Reviewer */}
              <div className="flex items-center gap-3 pt-4 border-t border-[#EDE7DF]">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${AVATAR_COLORS[idx % AVATAR_COLORS.length]} shrink-0`}>
                  <span className="text-[#8B7355] text-xs font-medium" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{t.avatar}</span>
                </div>
                <div>
                  <p className="text-[#3D2E2A] text-sm font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>{t.name}</p>
                  <p className="text-[#A8937A] text-xs" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{t.age}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
